import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import * as actions from 'actions';

import _ from "lodash";
import moment from "moment";

import withStyles from "@material-ui/core/styles/withStyles";

// material-ui icons
import Assignment from "@material-ui/icons/Assignment";

// core components
import Button from "components/CustomButtons/Button";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";

import Modal from 'react-modal';

import GradedPersonProfileStyle from "assets/jss/material-dashboard-pro-react/views/gradedPersonProfileStyle.jsx";

import defaultAvatar from "assets/img/placeholder.jpg";

import { Row, Col, Badge, Container } from 'reactstrap';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Accordion from 'components/Accordion/Accordion';
import DXFormViewerPrintable from 'components/Form/DXFormViewerPrintable';

const modalCustomStyles = {
  content: {
    top: '10%',
    left: '5%',
    right: '5%',
    bottom: '5%',
    backgroundColor: 'white',
    borderWidth: '1px',
    marginLeft: '260px',
    // transform: 'translate(-20%, -20%)',
  },
  overlay: {
    zIndex: 10,
    backgroundColor: 'rgba(255,255,255,0.4)'
  }
};

class GradedPersonProfile extends Component {
  static propTypes = {
    gradedPerson: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);
    const targetUser = this.props?.location?.state?.gradedPerson || this.props.gradedPerson;
    const org_id = this.props?.location?.state?.org_id || this.props.org_id;
    const { uid, name, profile_image_url = "", gender, birthday: rawBirthday } = targetUser;
    const birthday = rawBirthday.constructor.name !== "String"
      ? moment(birthday?.toDate())
      : moment(rawBirthday);

    const age = moment().diff(birthday, 'years');
    this.state = {
      target: {
        ..._.pick(targetUser, ['birthday', 'gender', 'grade_id', 'intro', 'name', 'org_id', 'profile_image_url']),
        age,
        uid,
      },
      user_id: targetUser.uid,
      org_id: org_id,
      uid,
      name,
      profile_image_url,
      gender,
      birthday,
      viewerModalIsOpen: false,
    }
  }



  componentDidMount() {
    const { org_id, user_id } = this.state;
    if (!this.unsubscribe) {
      this.unsubscribe = this.props.getDocsOfMemberAction(org_id, user_id);
    }
    if (!this.props.forms) {
      this.props.getFormsAction();
    }
    Modal.setAppElement("#root");
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  renderHeader1 = () => {
    const { classes } = this.props;
    const { uid, name, profile_image_url = "", gender, birthday } = this.state;

    return <Row className='mb-4'>
      <Col xs={{ size: 'auto' }}>
        <img className={classes.circle} src={profile_image_url.length === 0 ? defaultAvatar : profile_image_url} alt="등급자 프로필" />
      </Col>
      <Col xs={{ size: 'auto' }}>
        <h3 className='font-weight-bold'>{name}</h3>
        <h4>{`${moment().diff(birthday, 'years')}세`} / {gender === 0 ? "여" : "남"}</h4>
      </Col>
      <Col className='d-flex align-items-end justify-content-end'>
        <Button
          color="rose"
          onClick={() => this.props.history.push('/admin/dashboardForPerson',
            { uid: this.state.uid, org_id: this.state.org_id })}
        >개인 통계데이터</Button>
      </Col>
    </Row >
  }

  renderTitle = (title) => {
    const { classes } = this.props;
    return (
      <CardHeader color="rose" icon>
        <CardIcon color="rose">
          <Assignment />
        </CardIcon>
        <h4 className={classes.formSectionTitle}>{title}</h4>
      </CardHeader>
    )
  }
  renderDocs = () => {
    const { classes, forms = [], doc = {} } = this.props;

    // getting forms
    if (!forms) {
      return null;
    }
    const group_keys = Object.keys(forms);

    // getting docs
    const { user_id } = this.state;
    console.log("user_id = ", user_id);
    const docs = doc[user_id];

    if (!docs) {
      return null;
    }
    const docsData = docs.map(doc => ({ id: doc.id, ...doc.data() }));
    console.log("docsData = ", docsData);


    return <React.Fragment>
      {
        group_keys.map(group_key => {
          const selected_forms = forms[group_key];
          return (
            <Row key={group_key}>
              <Card>
                {this.renderTitle(group_key)}
                <Col className={classes.padding20px}>
                  {
                    selected_forms && selected_forms.map(form => {
                      const formData = form.data();
                      const hasDoc = _.some(docsData, { form: { sku: formData.sku } });
                      const selectedFormDocs = _.filter(docsData, { form: { sku: formData.sku } });
                      console.log("hasDoc = ", hasDoc);
                      console.log('selectedFormDocs = ', selectedFormDocs);
                      return <React.Fragment>
                        <Row style={{ paddingTop: '40px' }}>
                          <Col xs={{ size: 'auto' }}>
                            <h5><strong><Badge color='primary'>서식 {formData.서식}</Badge> {formData.평가도구}</strong></h5>
                          </Col>
                          <Col style={{ justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                            {
                              form.data().sku !== 'form02_04' && !this.props.readonly
                                ? <Button
                                  color="rose"
                                  size='sm'
                                  onClick={() => {
                                    console.log("sku = ", form.data().sku);
                                    if (form.data().sku === 'form04') {
                                      this.props.history.push('/admin/customForms/form04',
                                        {
                                          gradedPerson: this.state.target,
                                          org_id: this.state.org_id,
                                          currentDoc: null
                                        });
                                      return;
                                    }

                                    // create doc
                                    this.props.setCurrentForm(formData);
                                    this.props.history.push('/admin/wizard', {
                                      sku: formData.sku,
                                      target: this.state.target
                                    });

                                  }}
                                >
                                  신규 사례 작성
                              </Button>
                                : null
                            }
                            {
                              form.data().sku === 'form02_04' && !this.props.readonly
                                ? <Button
                                  size='sm'
                                  color="rose"
                                  onClick={() => {
                                    console.log("sku = ", form.data().sku);
                                    if (form.data().sku === 'form02_04') {
                                      this.props.history.push('/admin/customForms/form02_04',
                                        {
                                          gradedPerson: this.state.target,
                                          org_id: this.state.org_id,
                                        });
                                      return;
                                    }
                                  }}
                                >
                                  사례 관리
                              </Button>
                                : null
                            }
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            {
                              selectedFormDocs.length > 0
                                ? <Accordion
                                  active={1}
                                  collapses={[
                                    {
                                      title: "사례 목록",
                                      content: <Table className={classes.table} aria-label="simple table">
                                        <TableHead>
                                          <TableRow>
                                            <TableCell align="left">작성일자</TableCell>
                                            <TableCell align="right">작성자</TableCell>
                                          </TableRow>
                                        </TableHead>
                                        <TableBody>
                                          {selectedFormDocs.map((doc) => (
                                            <TableRow
                                              key={doc.id}
                                              onClick={e => {
                                                console.log("sku = ", form.data().sku);
                                                // if (form.data().sku === 'form04') {
                                                //   this.props.history.push('/admin/customForms/form04',
                                                //     {
                                                //       gradedPerson: this.state.target,
                                                //       org_id: this.state.org_id,
                                                //       currentDoc: doc
                                                //     });
                                                //   return;
                                                // }
                                                this.setState({
                                                  currentDoc: doc
                                                }, () => this.setState({ viewerModalIsOpen: true }))
                                              }}
                                              style={{ cursor: 'pointer' }}

                                            >
                                              <TableCell align="left">{doc.created_at ? moment(doc.created_at?.toDate()).format('YYYY-MM-DD') : null}</TableCell>
                                              <TableCell align='right' component="th" scope="row">
                                                {doc.reporter.displayName}
                                              </TableCell>
                                            </TableRow>
                                          ))}
                                        </TableBody>
                                      </Table>
                                    }
                                  ]}
                                />

                                : form.data().sku !== 'form02_04'
                                  ? <h6>등록된 사례가 없습니다.</h6>
                                  : null
                            }
                          </Col>
                        </Row>
                      </React.Fragment>
                    })
                  }
                </Col>
              </Card>
            </Row>
          )
        })
      }
    </React.Fragment>

  }

  closeModal = () => {
    this.setState({ viewerModalIsOpen: false });
  }
  render() {
    return (
      <Container>
        <Row>
          <Col>
            {!this.props.readonly && this.renderHeader1()}
          </Col>
        </Row>
        <Row>
          <Col>
            {this.renderDocs()}
          </Col>
        </Row>
        <Modal
          isOpen={this.state.viewerModalIsOpen}
          onRequestClose={() => this.setState({ viewerModalIsOpen: false })}
          style={modalCustomStyles}
          contentLabel="문서보기"
        >
          <DXFormViewerPrintable
            {...this.props}
            doc={this.state.currentDoc}
            onClose={this.closeModal}
          />

        </Modal>
      </Container>
    )
  }
}

const mapStateToProps = (state) => ({
  currentUser: state.auth.currentUser,
  currentOrg: state.org.currentOrg,
  doc: state.doc,
  forms: state.form.grouped_forms
})

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(actions, dispatch);
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(GradedPersonProfileStyle),
)(GradedPersonProfile);
